import React from "react";
import { Empty } from "antd";
import Loader from "./Loader";
import SomethingWentWrong from "./SomethingWentWrong";

const WrapperComponent = (
    Component, data, options
) => {
    return class extends React.Component {
        _baseClassName = 'wrapper-component';
        constructor(props) {
            super(props);

            this.state = {
            };
        }

        renderComponent() {
            
            if ((Array.isArray(data) && data.length) || (data != null && typeof data == "object" && Object.keys(data).length)) return Component;
            else if ((Array.isArray(data) && data.length == 0) || (data != null && typeof data == "object" && Object.keys(data).length == 0)) return <Empty description={options?.noDataContent || "No Data"} image={Empty.PRESENTED_IMAGE_SIMPLE}/>;
            else if (data ==  undefined) return <Loader />;
            else if (data == null) return <SomethingWentWrong handleRefresh={e => typeof options?.handleFunction == "function" && options?.handleFunction("refresh")}/>;
        }

        render() {
            return (
                <div className={this._baseClassName} style={{ 
                    display: "flex", 
                    justifyContent: "center", 
                    alignItems: "center", 
                    height: "100%", 
                    width: "100%",
                    flexDirection: "column" 
                }}>
                    {this.renderComponent()}
                </div>
                
            );
        }
    };
};

export default WrapperComponent;